module.exports = __webpack_public_path__ + "static/img/step2_valid_error.bd6ed23.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/publicauth/img/step2_valid_error.jpg
// module id = 727
// module chunks = 1